/**
 * Returns true if the app is running on a desktop platform.
 * Uses Telegram WebApp platform info when available, falls back to UA detection.
 */
export function useIsDesktop(): boolean {
  const platform = (window as any).Telegram?.WebApp?.platform as string | undefined;
  if (platform) {
    return ['tdesktop', 'macos', 'weba', 'webk'].includes(platform);
  }
  return window.innerWidth >= 768 && !/Mobi|Android/i.test(navigator.userAgent);
}
